import { CountryCode } from "./country-codes"

export interface Country {
  code: CountryCode
  callingCode: string
  name: string
  nativeName: string
}

export const countries: Country[] = [
  {
    code: 'AD',
    callingCode: '376',
    name: 'Andorra',
    nativeName: 'Andorra',
  },
  {
    code: 'AE',
    callingCode: '971',
    name: 'United Arab Emirates',
    nativeName: 'دولة الإمارات العربية المتحدة',
  },
  {
    code: 'AF',
    callingCode: '93',
    name: 'Afghanistan',
    nativeName: 'افغانستان',
  },
  {
    code: 'AG',
    callingCode: '1-268',
    name: 'Antigua and Barbuda',
    nativeName: 'Antigua and Barbuda',
  },
  {
    code: 'AI',
    callingCode: '1-264',
    name: 'Anguilla',
    nativeName: 'Anguilla',
  },
  {
    code: 'AL',
    callingCode: '355',
    name: 'Albania',
    nativeName: 'Shqipëria',
  },
  {
    code: 'AM',
    callingCode: '374',
    name: 'Armenia',
    nativeName: 'Հայաստան',
  },
  {
    code: 'AO',
    callingCode: '244',
    name: 'Angola',
    nativeName: 'Angola',
  },
  {
    code: 'AR',
    callingCode: '54',
    name: 'Argentina',
    nativeName: 'Argentina',
  },
  {
    code: 'AS',
    callingCode: '1-684',
    name: 'American Samoa',
    nativeName: 'American Samoa',
  },
  {
    code: 'AT',
    callingCode: '43',
    name: 'Austria',
    nativeName: 'Österreich',
  },
  {
    code: 'AU',
    callingCode: '61',
    name: 'Australia',
    nativeName: 'Australia',
  },
  {
    code: 'AW',
    callingCode: '297',
    name: 'Aruba',
    nativeName: 'Aruba',
  },
  {
    code: 'AZ',
    callingCode: '994',
    name: 'Azerbaijan',
    nativeName: 'Azərbaycan',
  },
  {
    code: 'BA',
    callingCode: '387',
    name: 'Bosnia and Herzegowina',
    nativeName: 'Bosna i Hercegovina',
  },
  {
    code: 'BB',
    callingCode: '1-246',
    name: 'Barbados',
    nativeName: 'Barbados',
  },
  {
    code: 'BD',
    callingCode: '880',
    name: 'Bangladesh',
    nativeName: 'Bangladesh',
  },
  {
    code: 'BE',
    callingCode: '32',
    name: 'Belgium',
    nativeName: 'België',
  },
  {
    code: 'BF',
    callingCode: '226',
    name: 'Burkina Faso',
    nativeName: 'Burkina Faso',
  },
  {
    code: 'BG',
    callingCode: '359',
    name: 'Bulgaria',
    nativeName: 'България',
  },
  {
    code: 'BH',
    callingCode: '973',
    name: 'Bahrain',
    nativeName: '‏البحرين',
  },
  {
    code: 'BI',
    callingCode: '257',
    name: 'Burundi',
    nativeName: 'Burundi',
  },
  {
    code: 'BJ',
    callingCode: '229',
    name: 'Benin',
    nativeName: 'Bénin',
  },
  {
    code: 'BL',
    callingCode: '590',
    name: 'Saint Barthélemy',
    nativeName: 'Saint-Barthélemy',
  },
  {
    code: 'BM',
    callingCode: '1-441',
    name: 'Bermuda',
    nativeName: 'Bermuda',
  },
  {
    code: 'BN',
    callingCode: '673',
    name: 'Brunei Darussalam',
    nativeName: 'Negara Brunei Darussalam',
  },
  {
    code: 'BO',
    callingCode: '591',
    name: 'Bolivia',
    nativeName: 'Bolivia',
  },
  {
    code: 'BR',
    callingCode: '55',
    name: 'Brazil',
    nativeName: 'Brasil',
  },
  {
    code: 'BS',
    callingCode: '1-242',
    name: 'Bahamas',
    nativeName: 'Bahamas',
  },
  {
    code: 'BT',
    callingCode: '975',
    name: 'Bhutan',
    nativeName: 'ʼbrug-yul',
  },
  {
    code: 'BW',
    callingCode: '267',
    name: 'Botswana',
    nativeName: 'Botswana',
  },
  {
    code: 'BY',
    callingCode: '375',
    name: 'Belarus',
    nativeName: 'Белару́сь',
  },
  {
    code: 'BZ',
    callingCode: '501',
    name: 'Belize',
    nativeName: 'Belize',
  },
  {
    code: 'CC',
    callingCode: '61',
    name: 'Cocos (Keeling) Islands',
    nativeName: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CD',
    callingCode: '243',
    name: 'Congo, the Democratic Republic of the',
    nativeName: 'République démocratique du Congo',
  },
  {
    code: 'CF',
    callingCode: '236',
    name: 'Central African Republic',
    nativeName: 'République centrafricaine',
  },
  {
    code: 'CG',
    callingCode: '242',
    name: 'Congo',
    nativeName: 'Congo',
  },
  {
    code: 'CH',
    callingCode: '41',
    name: 'Switzerland',
    nativeName: 'Schweiz',
  },
  {
    code: 'CI',
    callingCode: '225',
    name: "Cote d'Ivoire",
    nativeName: "Côte d'Ivoire",
  },
  {
    code: 'CK',
    callingCode: '682',
    name: 'Cook Islands',
    nativeName: 'Cook Islands',
  },
  {
    code: 'CL',
    callingCode: '56',
    name: 'Chile',
    nativeName: 'Chile',
  },
  {
    code: 'CM',
    callingCode: '237',
    name: 'Cameroon',
    nativeName: 'Cameroon',
  },
  {
    code: 'CN',
    callingCode: '86',
    name: 'China',
    nativeName: '中国',
  },
  {
    code: 'CO',
    callingCode: '57',
    name: 'Colombia',
    nativeName: 'Colombia',
  },
  {
    code: 'CR',
    callingCode: '506',
    name: 'Costa Rica',
    nativeName: 'Costa Rica',
  },
  {
    code: 'CU',
    callingCode: '53',
    name: 'Cuba',
    nativeName: 'Cuba',
  },
  {
    code: 'CV',
    callingCode: '238',
    name: 'Cape Verde',
    nativeName: 'Cabo Verde',
  },
  {
    code: 'CA',
    callingCode: '1',
    name: 'Canada',
    nativeName: 'Canada',
  },
  {
    code: 'CW',
    callingCode: '599',
    name: 'Netherlands Antilles',
    nativeName: 'Nederlandse Antillen',
  },
  {
    code: 'CX',
    callingCode: '61',
    name: 'Christmas Island',
    nativeName: 'Christmas Island',
  },
  {
    code: 'CY',
    callingCode: '357',
    name: 'Cyprus',
    nativeName: 'Κύπρος',
  },
  {
    code: 'CZ',
    callingCode: '420',
    name: 'Czech Republic',
    nativeName: 'Česká republika',
  },
  {
    code: 'DE',
    callingCode: '49',
    name: 'Germany',
    nativeName: 'Deutschland',
  },
  {
    code: 'DJ',
    callingCode: '253',
    name: 'Djibouti',
    nativeName: 'Djibouti',
  },
  {
    code: 'DK',
    callingCode: '45',
    name: 'Denmark',
    nativeName: 'Danmark',
  },
  {
    code: 'DM',
    callingCode: '1-767',
    name: 'Dominica',
    nativeName: 'Dominica',
  },
  {
    code: 'DO',
    callingCode: '1-849',
    name: 'Dominican Republic',
    nativeName: 'República Dominicana',
  },
  {
    code: 'DZ',
    callingCode: '213',
    name: 'Algeria',
    nativeName: 'الجزائر',
  },
  {
    code: 'EC',
    callingCode: '593',
    name: 'Ecuador',
    nativeName: 'Ecuador',
  },
  {
    code: 'EE',
    callingCode: '372',
    name: 'Estonia',
    nativeName: 'Eesti',
  },
  {
    code: 'EG',
    callingCode: '20',
    name: 'Egypt',
    nativeName: 'مصر',
  },
  {
    code: 'EH',
    callingCode: '212',
    name: 'Western Sahara',
    nativeName: 'الصحراء الغربية',
  },
  {
    code: 'ER',
    callingCode: '291',
    name: 'Eritrea',
    nativeName: 'ኤርትራ',
  },
  {
    code: 'ES',
    callingCode: '34',
    name: 'Spain',
    nativeName: 'España',
  },
  {
    code: 'ET',
    callingCode: '251',
    name: 'Ethiopia',
    nativeName: 'ኢትዮጵያ',
  },
  {
    code: 'FI',
    callingCode: '358',
    name: 'Finland',
    nativeName: 'Suomi',
  },
  {
    code: 'FJ',
    callingCode: '679',
    name: 'Fiji',
    nativeName: 'Fiji',
  },
  {
    code: 'FK',
    callingCode: '500',
    name: 'Falkland Islands (Malvinas)',
    nativeName: 'Falkland Islands (Malvinas)',
  },
  {
    code: 'FM',
    callingCode: '691',
    name: 'Micronesia, Federated States of',
    nativeName: 'Micronesia, Federated States of',
  },
  {
    code: 'FO',
    callingCode: '298',
    name: 'Faroe Islands',
    nativeName: 'Føroyar',
  },
  {
    code: 'FR',
    callingCode: '33',
    name: 'France',
    nativeName: 'France',
  },
  {
    code: 'GA',
    callingCode: '241',
    name: 'Gabon',
    nativeName: 'Gabon',
  },
  {
    code: 'GB',
    callingCode: '44',
    name: 'United Kingdom',
    nativeName: 'United Kingdom',
  },
  {
    code: 'GD',
    callingCode: '1-473',
    name: 'Grenada',
    nativeName: 'Grenada',
  },
  {
    code: 'GE',
    callingCode: '995',
    name: 'Georgia',
    nativeName: 'საქართველო',
  },
  {
    code: 'GG',
    callingCode: '44-1481',
    name: 'French Guiana',
    nativeName: 'French Guiana',
  },
  {
    code: 'GH',
    callingCode: '233',
    name: 'Ghana',
    nativeName: 'Ghana',
  },
  {
    code: 'GI',
    callingCode: '350',
    name: 'Gibraltar',
    nativeName: 'Gibraltar',
  },
  {
    code: 'GL',
    callingCode: '299',
    name: 'Greenland',
    nativeName: 'Kalaallit Nunaat',
  },
  {
    code: 'GM',
    callingCode: '220',
    name: 'Gambia',
    nativeName: 'Gambia',
  },
  {
    code: 'GN',
    callingCode: '224',
    name: 'Guinea',
    nativeName: 'Guinée',
  },
  {
    code: 'GQ',
    callingCode: '240',
    name: 'Equatorial Guinea',
    nativeName: 'Guinea Ecuatorial',
  },
  {
    code: 'GR',
    callingCode: '30',
    name: 'Greece',
    nativeName: 'Ελλάδα',
  },
  {
    code: 'GT',
    callingCode: '502',
    name: 'Guatemala',
    nativeName: 'Guatemala',
  },
  {
    code: 'GU',
    callingCode: '1-671',
    name: 'Guam',
    nativeName: 'Guam',
  },
  {
    code: 'GW',
    callingCode: '245',
    name: 'Guinea-Bissau',
    nativeName: 'Guiné-Bissau',
  },
  {
    code: 'GY',
    callingCode: '592',
    name: 'Guyana',
    nativeName: 'Guyana',
  },
  {
    code: 'HK',
    callingCode: '852',
    name: 'Hong Kong',
    nativeName: '香港',
  },
  {
    code: 'HN',
    callingCode: '504',
    name: 'Honduras',
    nativeName: 'Honduras',
  },
  {
    code: 'HR',
    callingCode: '385',
    name: 'Croatia (Hrvatska)',
    nativeName: 'Hrvatska',
  },
  {
    code: 'HT',
    callingCode: '509',
    name: 'Haiti',
    nativeName: 'Haïti',
  },
  {
    code: 'HU',
    callingCode: '36',
    name: 'Hungary',
    nativeName: 'Magyarország',
  },
  {
    code: 'ID',
    callingCode: '62',
    name: 'Indonesia',
    nativeName: 'Indonesia',
  },
  {
    code: 'IE',
    callingCode: '353',
    name: 'Ireland',
    nativeName: 'Éire',
  },
  {
    code: 'IL',
    callingCode: '972',
    name: 'Israel',
    nativeName: 'ישראל',
  },
  {
    code: 'IM',
    callingCode: '44-1624',
    name: 'Isle of Man',
    nativeName: 'Isle of Man',
  },
  {
    code: 'IN',
    callingCode: '91',
    name: 'India',
    nativeName: 'भारत',
  },
  {
    code: 'IO',
    callingCode: '246',
    name: 'British Indian Ocean Territory',
    nativeName: 'British Indian Ocean Territory',
  },
  {
    code: 'IQ',
    callingCode: '964',
    name: 'Iraq',
    nativeName: 'العراق',
  },
  {
    code: 'IR',
    callingCode: '98',
    name: 'Iran (Islamic Republic of)',
    nativeName: 'ایران',
  },
  {
    code: 'IS',
    callingCode: '354',
    name: 'Iceland',
    nativeName: 'Ísland',
  },
  {
    code: 'IT',
    callingCode: '39',
    name: 'Italy',
    nativeName: 'Italia',
  },
  {
    code: 'JE',
    callingCode: '44-1534',
    name: 'Jersey',
    nativeName: 'Jersey',
  },
  {
    code: 'JM',
    callingCode: '1-876',
    name: 'Jamaica',
    nativeName: 'Jamaica',
  },
  {
    code: 'JO',
    callingCode: '962',
    name: 'Jordan',
    nativeName: 'الأردن',
  },
  {
    code: 'JP',
    callingCode: '81',
    name: 'Japan',
    nativeName: '日本',
  },
  {
    code: 'KE',
    callingCode: '254',
    name: 'Kenya',
    nativeName: 'Kenya',
  },
  {
    code: 'KG',
    callingCode: '996',
    name: 'Kyrgyzstan',
    nativeName: 'Кыргызстан',
  },
  {
    code: 'KH',
    callingCode: '855',
    name: 'Cambodia',
    nativeName: 'Kâmpŭchéa',
  },
  {
    code: 'KI',
    callingCode: '686',
    name: 'Kiribati',
    nativeName: 'Kiribati',
  },
  {
    code: 'KM',
    callingCode: '269',
    name: 'Comoros',
    nativeName: 'Komori',
  },
  {
    code: 'KN',
    callingCode: '1-869',
    name: 'Saint Kitts and Nevis',
    nativeName: 'Saint Kitts and Nevis',
  },
  {
    code: 'KP',
    callingCode: '850',
    name: "Korea, Democratic People's Republic of",
    nativeName: '조선민주주의인민공화국',
  },
  {
    code: 'KR',
    callingCode: '82',
    name: 'Korea, Republic of',
    nativeName: '대한민국',
  },
  {
    code: 'KW',
    callingCode: '965',
    name: 'Kuwait',
    nativeName: 'الكويت',
  },
  {
    code: 'KY',
    callingCode: '1-345',
    name: 'Cayman Islands',
    nativeName: 'Cayman Islands',
  },
  {
    code: 'LA',
    callingCode: '856',
    name: "Lao People's Democratic Republic",
    nativeName: 'ສປປລາວ',
  },
  {
    code: 'LB',
    callingCode: '961',
    name: 'Lebanon',
    nativeName: 'لبنان',
  },
  {
    code: 'LC',
    callingCode: '1-758',
    name: 'Saint LUCIA',
    nativeName: 'Saint LUCIA',
  },
  {
    code: 'LI',
    callingCode: '423',
    name: 'Liechtenstein',
    nativeName: 'Liechtenstein',
  },
  {
    code: 'LK',
    callingCode: '94',
    name: 'Sri Lanka',
    nativeName: 'śrī laṃkāva',
  },
  {
    code: 'LR',
    callingCode: '231',
    name: 'Liberia',
    nativeName: 'Liberia',
  },
  {
    code: 'LS',
    callingCode: '266',
    name: 'Lesotho',
    nativeName: 'Lesotho',
  },
  {
    code: 'LT',
    callingCode: '370',
    name: 'Lithuania',
    nativeName: 'Lietuva',
  },
  {
    code: 'LU',
    callingCode: '352',
    name: 'Luxembourg',
    nativeName: 'Luxembourg',
  },
  {
    code: 'LV',
    callingCode: '371',
    name: 'Latvia',
    nativeName: 'Latvija',
  },
  {
    code: 'LY',
    callingCode: '218',
    name: 'Libyan Arab Jamahiriya',
    nativeName: '‏ليبيا',
  },
  {
    code: 'MA',
    callingCode: '212',
    name: 'Morocco',
    nativeName: 'المغرب',
  },
  {
    code: 'MC',
    callingCode: '377',
    name: 'Monaco',
    nativeName: 'Monaco',
  },
  {
    code: 'MD',
    callingCode: '373',
    name: 'Moldova, Republic of',
    nativeName: 'Moldova',
  },
  {
    code: 'ME',
    callingCode: '382',
    name: 'Montenegro',
    nativeName: 'Црна Гора',
  },
  {
    code: 'MG',
    callingCode: '261',
    name: 'Madagascar',
    nativeName: 'Madagasikara',
  },
  {
    code: 'MH',
    callingCode: '692',
    name: 'Marshall Islands',
    nativeName: 'M̧ajeļ',
  },
  {
    code: 'MK',
    callingCode: '389',
    name: 'Macedonia, The Former Yugoslav Republic of',
    nativeName: 'Македонија',
  },
  {
    code: 'ML',
    callingCode: '223',
    name: 'Mali',
    nativeName: 'Mali',
  },
  {
    code: 'MM',
    callingCode: '95',
    name: 'Myanmar',
    nativeName: 'မြန်မာ',
  },
  {
    code: 'MN',
    callingCode: '976',
    name: 'Mongolia',
    nativeName: 'Монгол улс',
  },
  {
    code: 'MO',
    callingCode: '853',
    name: 'Macau',
    nativeName: '澳門',
  },
  {
    code: 'MP',
    callingCode: '1-670',
    name: 'Northern Mariana Islands',
    nativeName: 'Northern Mariana Islands',
  },
  {
    code: 'MR',
    callingCode: '222',
    name: 'Mauritania',
    nativeName: 'موريتانيا',
  },
  {
    code: 'MS',
    callingCode: '1-664',
    name: 'Montserrat',
    nativeName: 'Montserrat',
  },
  {
    code: 'MT',
    callingCode: '356',
    name: 'Malta',
    nativeName: 'Malta',
  },
  {
    code: 'MU',
    callingCode: '230',
    name: 'Mauritius',
    nativeName: 'Moris',
  },
  {
    code: 'MV',
    callingCode: '960',
    name: 'Maldives',
    nativeName: 'ދިވެހި',
  },
  {
    code: 'MW',
    callingCode: '265',
    name: 'Malawi',
    nativeName: 'Malawi',
  },
  {
    code: 'MX',
    callingCode: '52',
    name: 'Mexico',
    nativeName: 'México',
  },
  {
    code: 'MY',
    callingCode: '60',
    name: 'Malaysia',
    nativeName: 'Malaysia',
  },
  {
    code: 'MZ',
    callingCode: '258',
    name: 'Mozambique',
    nativeName: 'Moçambique',
  },
  {
    code: 'NA',
    callingCode: '264',
    name: 'Namibia',
    nativeName: 'Namibia',
  },
  {
    code: 'NC',
    callingCode: '687',
    name: 'New Caledonia',
    nativeName: 'Nouvelle-Calédonie',
  },
  {
    code: 'NE',
    callingCode: '227',
    name: 'Niger',
    nativeName: 'Niger',
  },
  {
    code: 'NG',
    callingCode: '234',
    name: 'Nigeria',
    nativeName: 'Nigeria',
  },
  {
    code: 'NI',
    callingCode: '505',
    name: 'Nicaragua',
    nativeName: 'Nicaragua',
  },
  {
    code: 'NL',
    callingCode: '31',
    name: 'Netherlands',
    nativeName: 'Nederland',
  },
  {
    code: 'NO',
    callingCode: '47',
    name: 'Norway',
    nativeName: 'Norge',
  },
  {
    code: 'NP',
    callingCode: '977',
    name: 'Nepal',
    nativeName: 'नेपाल',
  },
  {
    code: 'NR',
    callingCode: '674',
    name: 'Nauru',
    nativeName: 'Nauru',
  },
  {
    code: 'NU',
    callingCode: '683',
    name: 'Niue',
    nativeName: 'Niuē',
  },
  {
    code: 'NZ',
    callingCode: '64',
    name: 'New Zealand',
    nativeName: 'New Zealand',
  },
  {
    code: 'OM',
    callingCode: '968',
    name: 'Oman',
    nativeName: 'عمان',
  },
  {
    code: 'PA',
    callingCode: '507',
    name: 'Panama',
    nativeName: 'Panamá',
  },
  {
    code: 'PE',
    callingCode: '51',
    name: 'Peru',
    nativeName: 'Perú',
  },
  {
    code: 'PF',
    callingCode: '689',
    name: 'French Polynesia',
    nativeName: 'Polynésie française',
  },
  {
    code: 'PG',
    callingCode: '675',
    name: 'Papua New Guinea',
    nativeName: 'Papua Niugini',
  },
  {
    code: 'PH',
    callingCode: '63',
    name: 'Philippines',
    nativeName: 'Pilipinas',
  },
  {
    code: 'PK',
    callingCode: '92',
    name: 'Pakistan',
    nativeName: 'پاکستان',
  },
  {
    code: 'PL',
    callingCode: '48',
    name: 'Poland',
    nativeName: 'Polska',
  },
  {
    code: 'PM',
    callingCode: '508',
    name: 'St. Pierre and Miquelon',
    nativeName: 'Saint-Pierre-et-Miquelon',
  },
  {
    code: 'PR',
    callingCode: '1-939',
    name: 'Puerto Rico',
    nativeName: 'Puerto Rico',
  },
  {
    code: 'PS',
    callingCode: '970',
    name: 'Palestine',
    nativeName: 'فلسطين',
  },
  {
    code: 'PT',
    callingCode: '351',
    name: 'Portugal',
    nativeName: 'Portugal',
  },
  {
    code: 'PW',
    callingCode: '680',
    name: 'Palau',
    nativeName: 'Palau',
  },
  {
    code: 'PY',
    callingCode: '595',
    name: 'Paraguay',
    nativeName: 'Paraguay',
  },
  {
    code: 'QA',
    callingCode: '974',
    name: 'Qatar',
    nativeName: 'قطر',
  },
  {
    code: 'RE',
    callingCode: '262',
    name: 'Reunion',
    nativeName: 'La Réunion',
  },
  {
    code: 'RO',
    callingCode: '40',
    name: 'Romania',
    nativeName: 'România',
  },
  {
    code: 'RS',
    callingCode: '381',
    name: 'Serbia',
    nativeName: 'Србија',
  },
  {
    code: 'RU',
    callingCode: '7',
    name: 'Russian Federation',
    nativeName: 'Россия',
  },
  {
    code: 'RW',
    callingCode: '250',
    name: 'Rwanda',
    nativeName: 'Rwanda',
  },
  {
    code: 'SA',
    callingCode: '966',
    name: 'Saudi Arabia',
    nativeName: 'العربية السعودية',
  },
  {
    code: 'SB',
    callingCode: '677',
    name: 'Solomon Islands',
    nativeName: 'Solomon Islands',
  },
  {
    code: 'SC',
    callingCode: '248',
    name: 'Seychelles',
    nativeName: 'Seychelles',
  },
  {
    code: 'SD',
    callingCode: '249',
    name: 'Sudan',
    nativeName: 'السودان',
  },
  {
    code: 'SE',
    callingCode: '46',
    name: 'Sweden',
    nativeName: 'Sverige',
  },
  {
    code: 'SG',
    callingCode: '65',
    name: 'Singapore',
    nativeName: 'Singapore',
  },
  {
    code: 'SH',
    callingCode: '290',
    name: 'St. Helena',
    nativeName: 'St. Helena',
  },
  {
    code: 'SI',
    callingCode: '386',
    name: 'Slovenia',
    nativeName: 'Slovenija',
  },
  {
    code: 'SJ',
    callingCode: '47',
    name: 'Svalbard and Jan Mayen Islands',
    nativeName: 'Svalbard og Jan Mayen',
  },
  {
    code: 'SK',
    callingCode: '421',
    name: 'Slovakia (Slovak Republic)',
    nativeName: 'Slovensko',
  },
  {
    code: 'SL',
    callingCode: '232',
    name: 'Sierra Leone',
    nativeName: 'Sierra Leone',
  },
  {
    code: 'SM',
    callingCode: '378',
    name: 'San Marino',
    nativeName: 'San Marino',
  },
  {
    code: 'SN',
    callingCode: '221',
    name: 'Senegal',
    nativeName: 'Sénégal',
  },
  {
    code: 'SO',
    callingCode: '252',
    name: 'Somalia',
    nativeName: 'Soomaaliya',
  },
  {
    code: 'SR',
    callingCode: '597',
    name: 'Suriname',
    nativeName: 'Suriname',
  },
  {
    code: 'SS',
    callingCode: '211',
    name: 'South Sudan',
    nativeName: 'South Sudan',
  },
  {
    code: 'ST',
    callingCode: '239',
    name: 'Sao Tome and Principe',
    nativeName: 'São Tomé e Príncipe',
  },
  {
    code: 'SV',
    callingCode: '503',
    name: 'El Salvador',
    nativeName: 'El Salvador',
  },
  {
    code: 'SX',
    callingCode: '1-721',
    name: 'Sint Maarten',
    nativeName: 'Sint Maarten',
  },
  {
    code: 'SY',
    callingCode: '963',
    name: 'Syrian Arab Republic',
    nativeName: 'سوريا',
  },
  {
    code: 'SZ',
    callingCode: '268',
    name: 'Swaziland',
    nativeName: 'Swaziland',
  },
  {
    code: 'TC',
    callingCode: '1-649',
    name: 'Turks and Caicos Islands',
    nativeName: 'Turks and Caicos Islands',
  },
  {
    code: 'TD',
    callingCode: '235',
    name: 'Chad',
    nativeName: 'Tchad',
  },
  {
    code: 'TG',
    callingCode: '228',
    name: 'Togo',
    nativeName: 'Togo',
  },
  {
    code: 'TH',
    callingCode: '66',
    name: 'Thailand',
    nativeName: 'ประเทศไทย',
  },
  {
    code: 'TJ',
    callingCode: '992',
    name: 'Tajikistan',
    nativeName: 'Тоҷикистон',
  },
  {
    code: 'TK',
    callingCode: '690',
    name: 'Tokelau',
    nativeName: 'Tokelau',
  },
  {
    code: 'TL',
    callingCode: '670',
    name: 'Northern Mariana Islands',
    nativeName: 'Northern Mariana Islands',
  },
  {
    code: 'TM',
    callingCode: '993',
    name: 'Turkmenistan',
    nativeName: 'Türkmenistan',
  },
  {
    code: 'TN',
    callingCode: '216',
    name: 'Tunisia',
    nativeName: 'تونس',
  },
  {
    code: 'TO',
    callingCode: '676',
    name: 'Tonga',
    nativeName: 'Tonga',
  },
  {
    code: 'TR',
    callingCode: '90',
    name: 'Turkey',
    nativeName: 'Türkiye',
  },
  {
    code: 'TT',
    callingCode: '1-868',
    name: 'Trinidad and Tobago',
    nativeName: 'Trinidad and Tobago',
  },
  {
    code: 'TV',
    callingCode: '688',
    name: 'Tuvalu',
    nativeName: 'Tuvalu',
  },
  {
    code: 'TW',
    callingCode: '886',
    name: 'Taiwan, Province of China',
    nativeName: 'Taiwan, Province of China',
  },
  {
    code: 'TZ',
    callingCode: '255',
    name: 'Tanzania, United Republic of',
    nativeName: 'Tanzania, United Republic of',
  },
  {
    code: 'UA',
    callingCode: '380',
    name: 'Ukraine',
    nativeName: 'Україна',
  },
  {
    code: 'UG',
    callingCode: '256',
    name: 'Uganda',
    nativeName: 'Uganda',
  },
  {
    code: 'US',
    callingCode: '1',
    name: 'United States',
    nativeName: 'United States',
  },
  {
    code: 'UY',
    callingCode: '598',
    name: 'Uruguay',
    nativeName: 'Uruguay',
  },
  {
    code: 'UZ',
    callingCode: '998',
    name: 'Uzbekistan',
    nativeName: 'Oʻzbekiston',
  },
  {
    code: 'VA',
    callingCode: '379',
    name: 'Holy See (Vatican City State)',
    nativeName: 'Holy See (Vatican City State)',
  },
  {
    code: 'VC',
    callingCode: '1-784',
    name: 'Saint Vincent and the Grenadines',
    nativeName: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'VE',
    callingCode: '58',
    name: 'Venezuela',
    nativeName: 'Venezuela',
  },
  {
    code: 'VG',
    callingCode: '1-284',
    name: 'Virgin Islands (British)',
    nativeName: 'Virgin Islands (British)',
  },
  {
    code: 'VI',
    callingCode: '1-340',
    name: 'Virgin Islands (U.S.)',
    nativeName: 'Virgin Islands (U.S.)',
  },
  {
    code: 'VN',
    callingCode: '84',
    name: 'Viet Nam',
    nativeName: 'Việt Nam',
  },
  {
    code: 'VU',
    callingCode: '678',
    name: 'Vanuatu',
    nativeName: 'Vanuatu',
  },
  {
    code: 'WF',
    callingCode: '681',
    name: 'Wallis and Futuna Islands',
    nativeName: 'Wallis and Futuna Islands',
  },
  {
    code: 'WS',
    callingCode: '685',
    name: 'Samoa',
    nativeName: 'Samoa',
  },
  {
    code: 'XK',
    callingCode: '383',
    name: 'Kosovo',
    nativeName: 'Kosovo',
  },
  {
    code: 'YE',
    callingCode: '967',
    name: 'Yemen',
    nativeName: 'Yemen',
  },
  {
    code: 'YT',
    callingCode: '262',
    name: 'Mayotte',
    nativeName: 'Mayotte',
  },
  {
    code: 'ZA',
    callingCode: '27',
    name: 'South Africa',
    nativeName: 'South Africa',
  },
  {
    code: 'ZM',
    callingCode: '260',
    name: 'Zambia',
    nativeName: 'Zambia',
  },
  {
    code: 'ZW',
    callingCode: '263',
    name: 'Zimbabwe',
    nativeName: 'Zimbabwe',
  },
]
